module.exports = __webpack_public_path__ + "static/k-drinks-banner-986f292f6c312c7a89103d0bbfe8ab55.jpg";